import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import { CircularProgress, Typography, Box } from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";

const ApplicationDay = () => {
  // Use useFirestore to fetch data from 'ApplicationDay' collection, ordered by 'Date_Submitted' descending
  const { data, loading, error } = useFirestore(
    "ApplicationDay",
    "Date_Submitted",
    "desc",
  );

  const columns = [
    {
      field: "Date_Submitted",
      headerName: "Date Submitted",
      width: 150,
    },
    {
      field: "schoolName",
      headerName: "School Name",
      flex: 1,
    },
    {
      field: "applicationDate",
      headerName: "Application Day Date",
      width: 150,
    },
    {
      field: "timeframe",
      headerName: "Timeframe",
      width: 150,
    },
    {
      field: "numberOfStudents",
      headerName: "Number of Students",
      width: 150,
      type: "number",
    },
    {
      field: "computerUsage",
      headerName: "Computer Usage",
      flex: 1,
    },
    {
      field: "fromName",
      headerName: "From Name",
      flex: 1,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 130,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "schoolId",
      headerName: "School ID",
      width: 100,
    },
    {
      field: "pathwayEmail",
      headerName: "Pathway Email",
      flex: 1,
    },
    {
      field: "opEmail",
      headerName: "OP Email",
      flex: 1,
    },
  ];

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <Typography color="error">Error loading data: {error}</Typography>
      </Box>
    );
  }

  // Debug: Log the data to see what we're receiving
  console.log("ApplicationDay data:", data);
  if (data && data.length > 0) {
    console.log("First record:", data[0]);
  }

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      <AppDataGrid
        rows={data}
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination
        initialState={{
          pagination: {
            paginationModel: { pageSize: 25, page: 0 },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
      />
    </Box>
  );
};

export default ApplicationDay;
